export enum Colors {
  GREEN = '#54C247',
  YELLOW = '#F49A0B',
  BLUE = '#036FF4',
  RED = '#ff0000'
}



export enum Status{
  OK = 0, // GREEN
  PROCESS = 1, // YELLOW
  WAITING = 2, // BLUE
  ALERT = 3, // YELLOW
  REJECT = 4 // RED
}
